import { observer } from 'mobx-react-lite'
import { requiresUserLoggedIn } from '../../../AuthFlow/AuthFlowModal'
import { Box } from '../../../core/Components'
import { Modal } from '../../../core/Modal'
import CompetitionInfoModalContent from './CompetitionInfoModalContent'

export const CompetitionInfoModal = observer(({ trigger }: { trigger: JSX.Element }) => {
  const wrappedTrigger = requiresUserLoggedIn(trigger)

  return (
    <Modal trigger={wrappedTrigger} noPadding>
      <Box css={{ padding: '32px' }}>
        <CompetitionInfoModalContent />
      </Box>
    </Modal>
  )
})
